'use client';

import type { ReactNode } from 'react';

import { PulseProvider } from '@pulse/react';

import { remoteSettings } from '@/configs/remoteSettings';
import isServer from '@/utils/isServer';

type PulseProviderClientProps = {
  children: ReactNode;
};

const PulseProviderWrapper = ({ children }: PulseProviderClientProps) => {
  if (isServer()) return children;
  return <PulseProvider {...remoteSettings}>{children}</PulseProvider>;
};

export default PulseProviderWrapper;
